import { render, staticRenderFns } from "./ArticleHistory.vue?vue&type=template&id=f6997e56&scoped=true"
import script from "./ArticleHistory.vue?vue&type=script&lang=js"
export * from "./ArticleHistory.vue?vue&type=script&lang=js"
import style0 from "./ArticleHistory.vue?vue&type=style&index=0&id=f6997e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6997e56",
  null
  
)

export default component.exports